import { Component, Input, Output, EventEmitter } from '@angular/core';
import {  Router } from '@angular/router';
import { DataService } from '../data.service';
import { urls } from '../urls';

@Component({
  selector: 'app-cpn-msn-explorer',
  templateUrl: './cpn-msn-explorer.component.html',
  styleUrls: ['./cpn-msn-explorer.component.scss']
})
export class CpnMsnExplorerComponent {

  @Input() isPopupOpen: boolean = false;
  @Output() popupClosed = new EventEmitter<void>();

    
constructor(
  private dataService: DataService,
  private router: Router
) {}

  cpn = '';

  customers: any[] = [];

  mappedMsns: { [customerName: string]: any[] } = {};

  customerLoading: boolean = false;
  msnLoading: boolean = false;
  activeAccordion: number = -1;


  openPopup(): void {
    this.isPopupOpen = true;
  }

  closePopup(): void {
    this.isPopupOpen = false;
  }

  submit(): void {
    console.log('Submitted');
    this.closePopup();
  }

  fetchCustomers(): void {

    this.customerLoading = true;

    const payload = {
      productCpn: this.cpn,
      countryCode: 356,
      businessUnit: 'MOGLIX-ENTERPRISE-INDIA',
      pageNo: 0
    };
this.mappedMsns={};
    this.dataService.callRestful(
      'POST',
      urls.fetchAllCustomerWithCpn,
      payload
    ).subscribe(
      response => {
        this.dataService.offSpinner();
        this.customerLoading = false;

        if (response && response.status) {
          this.customers = response.data || [];
        }
        if(this.customers.length > 0) {
         this.toggleAccordion(0, this.customers[0]);
        }
       
      },
      error => {
        this.customerLoading = false;
        this.dataService.offSpinner();
        console.error(error);
      }
    );
  }

   toggleAccordion(index: number, customer: any): void {
    if (this.activeAccordion === index) {
      this.activeAccordion = -1;
      return;
    }
    this.activeAccordion = index;
    if (!this.mappedMsns[customer.customerName]) {
        this.fetchMappedMsns(customer.customerName);
    }
  }
fetchMappedMsns(customerName: string): void {

    this.msnLoading = true;

    const payload = {
      productCpn: this.cpn,
      countryCode: 356,
      customerName: customerName,
      businessUnit: 'MOGLIX-ENTERPRISE-INDIA',
      pageNo: 0
    };
    this.dataService.callRestful(
      'POST',
      urls.fetchAllMappedMsns,
      payload
    ).subscribe(
      response => {
        this.dataService.offSpinner();
        this.msnLoading = false;

        if (response && response.status) {
          this.mappedMsns[customerName] = response.data || [];
        }

      },
      error => {
        this.dataService.offSpinner();
        this.msnLoading = false;
        console.error(error);
      }
    );
  }


 openProduct(msn: string): void {
    window.open(
      '/product-detail?productId=' + msn,
      '_blank'
    );
  }

}
